import React from 'react'
import t from '../../../../../translations/main'
import utils from '../../../../../components/Organisms/Form/utils'
import globalConfig from 'src/components/Organisms/Form/config'

import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'
import { ExternalLink } from 'src/components/Core/Styles/Link'

import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'
import { ConfigCompanyDetails } from '../../CorporateAccount/CompanyDetails/types'

export const cosecLink = <ExternalLink paddingBottom='0' href='https://www.elementalcosec.com/terms-and-conditions-of-service/terms-and-conditions-for-process-agent-service/' />

const config = ({ countryTelephoneCodes }: ConfigCompanyDetails) =>  utils.injectTranslation({
  id: 'UkProcessAgentForm',
  path: 'onboarding.forms.IndividualAccount.UkProcessAgentForm.inputs',
  keysToRemove: ['visual'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px'
      },
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'inUK',
            margin: '8px 0 0 0',
            dataList: [
              {
                id: 'inUK1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'inUK2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeAppointment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeElemental',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'break-spaces',
            },
            translationComponent: {cosecLink, requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeProvideContactInformation',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeSucdenToPayFees',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'name',
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'date',
          transformType: 'date',
          submitValidation: 'date',
          props: {
            name: 'dateOfBirth',
            required: true,
            noFuture: true,
            dontClearValue: true
          },
        }
      ]
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'residentialAddress',
            removeLabelEllipsis: true,
            required: true,
            isTextarea: true,
            textAreaHeight: '32px',
            textAreaPointerEvents: 'auto',
            resize: 'none'
          },
        }
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px',
        gridTemplateColumns: '1fr 1fr'
      },
      content: [
        {
          componentType: 'input',
          submitValidation: 'email',
          props: {
            name: 'email',
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'phoneNumberCountryIndex',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countryTelephoneCodes,
            name: 'phoneNumberCountryIndex',
            label: 'onboarding.forms.IndividualAccount.UkProcessAgentForm.inputs.phoneNumberCountryIndex.label',
            placeholder: 'onboarding.forms.IndividualAccount.UkProcessAgentForm.inputs.phoneNumberCountryIndex.placeholder',
            required: true,
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          transformType: 'transformValidationTelephoneCodePlusNumber',
          props: {
            name: 'validationPhoneNumberCountryIndex',
            show: false,
          },
        },
        {
          componentType: 'input',
          submitValidation: 'telephoneWithMinimum',
          transformType: 'transformTelephoneNumber',
          props: {
            name: 'phoneNumber',
            pattern: globalConfig?.regex?.telephoneNoPlusSignal,
            removeLabelEllipsis: true,
            required: true,
          },
        },
      ]
    }
  ],
})

export default config
